module.exports = __webpack_public_path__ + "static/img/bg_reward_item_white.81c3f28f.svg";